import { CommonModule } from '@angular/common';
import { Component, Input, Signal, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { AccordionDirective } from 'src/app/directives/accordion.directive';
import { ECommerceReservation, InTransitDetail, StockInfo, StoreStock } from 'src/app/models/types/Product/Stock.type';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-my-store-stock',
  imports: [CommonModule, TranslateModule, AccordionDirective, ModalComponent],
  templateUrl: './my-store-stock.component.html',
  styleUrl: './my-store-stock.component.scss'
})
export class MyStoreStockComponent {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  @Input('storeStock') storeStock!: Signal<StoreStock | null>;

  public get s4StockIsTrue(): boolean {
    return this.storeStock()?.s4Stock === true;
  }

  public get showOther(): boolean {
    return !!this.storeStock()?.myStore;
  }

  public get mainStock(): StockInfo | undefined {
    return this.storeStock()?.mainStock;
  }

  public get eCommerceReservation(): ECommerceReservation[] | null {
    let reservation = this.storeStock()?.reservation;
    if (reservation && reservation.length > 0) {
      return reservation;
    }
    return null;
  }

  public get eCommerceReservationTotal(): number {
    let total = 0;
    if (this.eCommerceReservation) {
      return this.eCommerceReservation.reduce((sum, item) => sum + item.quantity, 0);
    }
    return total;
  }

  public get consignmentIn(): StockInfo | undefined {
    return this.storeStock()?.consignmentIn;
  }

  public get omniChannel(): StockInfo | undefined {
    return this.storeStock()?.omniChannel;
  }

  public get inTransit(): InTransitDetail[] {
    return this.storeStock()?.inTransit || [];
  }

  public get s4stock(): boolean {
    return !!this.storeStock()?.s4Stock;
  }

  public get showRealTimeBanner(): boolean {
    return this.storeStock()?.isRealTime === false;
  }

  constructor(public readonly authService: AuthService) { }

  handleECommerceReservationClick(): void {
    this.openModal();
  }

  openModal() {
    this.modal.buildModal(() => this.handleClose());
  }
  private handleClose() {
    this.modal.dismiss();
  }

}
